import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeOnFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.33317 10.0002C8.33317 9.07969 9.07936 8.3335 9.99984 8.3335C10.9203 8.3335 11.6665 9.07969 11.6665 10.0002C11.6665 10.9206 10.9203 11.6668 9.99984 11.6668C9.07936 11.6668 8.33317 10.9206 8.33317 10.0002Z",
		fill: "white"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.95398 5.85734C5.37156 4.49646 7.44367 3.3335 9.99984 3.3335C12.556 3.3335 14.6281 4.49646 16.0457 5.85734C16.7551 6.53836 17.315 7.28183 17.702 7.98281C18.077 8.66207 18.3332 9.38055 18.3332 10.0002C18.3332 10.6198 18.077 11.3383 17.702 12.0175C17.315 12.7185 16.7551 13.462 16.0457 14.143C14.6281 15.5039 12.556 16.6668 9.99984 16.6668C7.44367 16.6668 5.37156 15.5039 3.95398 14.143C3.24458 13.462 2.68464 12.7185 2.29764 12.0175C1.92264 11.3383 1.6665 10.6198 1.6665 10.0002C1.6665 9.38055 1.92264 8.66207 2.29764 7.98281C2.68464 7.28183 3.24458 6.53836 3.95398 5.85734ZM9.99984 6.66683C8.15889 6.66683 6.6665 8.15921 6.6665 10.0002C6.6665 11.8411 8.15889 13.3335 9.99984 13.3335C11.8408 13.3335 13.3332 11.8411 13.3332 10.0002C13.3332 8.15921 11.8408 6.66683 9.99984 6.66683Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgEyeOnFilled);
export default ForwardRef;
